export default "__VITE_ASSET__EeuvRJmW__"